import React from 'react';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import LeaveBalances from './LeaveBalances';

const EmployeeLeavesBalancesList = () => {
  const id = useEmployeeId();

  if (!id) {
    return null;
  }

  return <LeaveBalances id={id} />;
};

export default EmployeeLeavesBalancesList;
